import { StateNode, TLStateNodeConstructor } from "tldraw"
import { MarkerIdle } from "./MarkerIdle"
import { MarkerDrawing } from "./MarkerDrawing"

export class MarkerTool extends StateNode {
  static override id = "marker"
  static override initial = "marker-idle"
  static override children(): TLStateNodeConstructor[] {
    return [MarkerIdle, MarkerDrawing]
  }

  override shapeType = "marker-shape"
}
